import ShareLinks from './share-link.js';
import USA from './usa-helpers.js';

window.ELEVATION = {

  step: 50,
  goalMeter: GOAL.meters,
  goalFeet: GOAL.feet,
  setScaleUnit() {
    this.goal = USA.isUSA() ? this.goalFeet : this.goalMeter;
    this.unit = USA.isUSA() ? ' ft' : 'm';
  },

  loadingMsgTimeout: null,
  lastPosition: {
    lat: null,
    lng: null
  },
  isOffline: false,

  init(offline) {
    this.isOffline = offline;
    this.setScaleUnit();

    this.scaleElement = document.querySelector('.scale');
    this.scaleElement
      .addEventListener('scroll', () => this.updateLevelZindex());

    window.addEventListener('resize', () => this.updateScaleHeight());

    if (localStorageIsUsable && localStorage.peakReached == 1) {
      this.updateTemplate(this.goal);
    }
    else {
      if (offline) {
        var errorMsg = TRANSLATE.text.level.headline.geolocationerror;
        $(this.scaleElement).stop(true);
        this.updateHeadlineMessage(false, errorMsg.offline);
      }
      if ("geolocation" in navigator) {

        if (!offline) {
          this.googleAPI.instance = new google.maps.ElevationService;
        }
        navigator.geolocation.watchPosition(
          position => this.onNewPosition(position, offline),
          error => {
            var errorMsg = TRANSLATE.text.level.headline.geolocationerror;
            const title = offline ? false : errorMsg.title;
            const details = offline ? errorMsg.offline :
              `${errorMsg.details}
                <div>
                  <a class="headline__support" href="${this.getSupportLink()}" target="_blank">
                    ${errorMsg.support}
                  </a>
                </div>`;

            console.log(error.message);
            this.updateHeadlineMessage(title, details);
          });
      }
    }
  },

  onNewPosition(position, offline) {
    console.log(position);

    if (localStorage.peakReached) {
      return;
    }
    if (position.coords.altitude) {
      this.animateUpdateTemplate(position.coords.altitude);
    }
    else if (offline) {
      const errorMsg = TRANSLATE.text.level.headline.geolocationerror;
      $(this.scaleElement).stop(true);
      this.updateHeadlineMessage(errorMsg.title, errorMsg.offline);
    }
    else {
      clearTimeout(this.loadingMsgTimeout);
      this.loadingMsgTimeout = setTimeout(() => {
        this.updateScaleStatus(TRANSLATE.text.level.scale.loading);
      }, 400);

      this.googleAPI.request(
        position.coords.latitude, position.coords.longitude);
    }
  },

  pageload() {
    this.resetScale();
    this.addLinkToShareButtons();
    this.handleChallengeCompletedFormSubmit();

    window.addEventListener('load', () => this.updateScaleHeight());
  },

  resetScale() {
    this.setScaleUnit();
    this.updateScaleStepElements();
    this.updateScaleHeight();
    const proceedWithUpdate = !this.isOffline && localStorageIsUsable
      && localStorage.accumulatedAltitude;

    if (proceedWithUpdate) {
      this.animateUpdateTemplate(localStorage.lastStoredAltitude);
    } else {
      this.updateScale(65);
    }
    this.updatePlaceElements();
  },

  updateScaleStepElements() {
    const list = document.querySelector('.scale__list');
    const level = list.querySelector('.scale__level');
    const blockWrap = list.querySelector('.scale__block-wrap');
    blockWrap.innerHTML = "";

    for (var i = this.goal; i > 0; i -= this.step) {
      const li = document.createElement('li');
      li.className = `scale__block scale__block--${i}`;
      li.innerHTML = `${i} ${this.unit.toUpperCase()}`;

      blockWrap.appendChild(li);
    }
    const blockHeight = blockWrap.firstChild.offsetHeight;
    const stepCount = this.goal / this.step;
    const scaleHeight = stepCount * blockHeight;

    level.style.height = `${scaleHeight + (blockHeight * 2)}px`;
    list.style.maxHeight = `${scaleHeight}px`;
  },

  updatePlaceElements() {
    const places = [
      {
        title: [ "Grouse Mountain" ],
        altitude: 1231
      },
      {
        title: [ "MT Snowdon" ],
        altitude: 1085
      },
      {
        title: [ "Bürglen (Albis)" ],
        altitude: 915
      },
      {
        title: [ "Burj Khalifa" ],
        altitude: 828
      },
      {
        title: [ "Shanghai Tower" ],
        altitude: 632
      },
      {
        title: [ "One World Trade", "Center" ],
        altitude: 541
      },
      {
        title: [ "Petronas Towers" ],
        altitude: 452
      }
    ];
    this.placeWrapper = this.placeWrapper
      || this.scaleElement.querySelector('.scale__places-wrap');

    this.placeWrapper.innerHTML = '';

    places.map(place => {
      if (place.altitude > this.goalMeter - 30) {
        return;
      }
      const parent = document.createElement('div');
      parent.className = "scale__places";
      this.updateScale(place.altitude, parent);

      const arrow = document.createElement('div');
      arrow.className = "o-arrow-top-sml";
      parent.appendChild(arrow);

      const title = document.createElement('div');
      title.className = "scale__places-title";
      title.innerHTML = `${place.title.join('<br>')}<br>` +
        `${this.formatAltitude(place.altitude)}${this.unit}`;
      parent.appendChild(title);

      this.placeWrapper.appendChild(parent);
    });
  },

  addLinkToShareButtons() {
    const links = ShareLinks.getAll({
      text: TRANSLATE.text.level.headline.social.msg,
      url: this.getRootUrl(),
      hashtags: TRANSLATE.text.level.headline.social.hashtags
    });
    const buttonWrapper = document.querySelector('.headline__buttons');
    const buttons = buttonWrapper.querySelectorAll('.headline__share-button');
    buttons.forEach(button => {
      const shareAttr = button.getAttribute('data-share-link');
      if (links[shareAttr]) {
        button.href = links[shareAttr];
      }
      button.addEventListener('click', () =>
        ga('send', 'event', 'up-the-alps', 'social sharing', shareAttr));
    });
  },

  updateTemplate(altitude, animated) {
    const accumulatedAltitude = animated ? Math.round(altitude) :
      Math.round(this.updateStoredAltitude(altitude));
    this.updateHeadline(accumulatedAltitude);

    if (accumulatedAltitude !== null) {
      this.updateScale(accumulatedAltitude);
      this.updateScaleStatus(accumulatedAltitude);
      this.updateLastUpdateTimestamp();
      this.updateLevelZindex();
    }
    return accumulatedAltitude;
  },

  updateStoredAltitude(altitude) {
    if (!localStorageIsUsable) {
      return null;
    }
    const storage = window.localStorage;
    var accumulated = parseFloat(storage.accumulatedAltitude || 0);
    var diff = 0;

    if (storage.lastStoredAltitude) {
      diff = altitude - parseFloat(storage.lastStoredAltitude);
    }
    if (diff > 0) {
      accumulated += diff;
    }
    this.sendAltitudeReachedToAnalytics(accumulated);

    storage.accumulatedAltitude = accumulated;
    storage.lastStoredAltitude = altitude;

    return accumulated;
  },

  updateHeadline(altitude, altitudeIsFormatted) {
    if (!altitudeIsFormatted) {
      altitude = this.formatAltitude(altitude);
    }
    var headlineElement = document.querySelector('article.headline');
    var titleElement = headlineElement.querySelector('.js-headline-title');
    var detailsElement = headlineElement.querySelector('.js-headline-details');
    var buttonElement = headlineElement.querySelector('.headline__buttons');

    if (altitude === null) {
      const isPrivateWindow = !localStorageIsUsable && window.localStorage;
      var errorMsg = TRANSLATE.text.level.headline.localestorage_error;
      titleElement.innerHTML = errorMsg.title;
      detailsElement.innerHTML =
        errorMsg[isPrivateWindow ? 'noprivate' : 'details'];
      buttonElement.classList.add('headline__buttons--hidden');
    }
    else if (altitude >= this.goal) {
      titleElement.innerHTML = TRANSLATE.text.level.headline.reached;
      detailsElement.innerHTML = TRANSLATE.text.level.headline.successdetails;
      buttonElement.classList.remove('headline__buttons--hidden');
      if (!localStorage.peakReached) {
        this.submitChallengeCompletedForm();
      } else {
        this.challengeCompletedForm.addLoadingMessage();
        this.challengeCompletedForm.showSuccessMessage();
      }
    }
    else {
      titleElement.innerHTML =
        `${TRANSLATE.text.level.headline.inprogress} ` +
        `<div class="headline__title-altitude">` +
          `${altitude}${this.unit.toUpperCase()}` +
        `</div>`;

      var details = TRANSLATE.text.level.headline.details;
      if (USA.isUSA()) {
        details = details.replace(
          new RegExp(`${this.goalMeter} ?m`, 'g'), this.goalFeet + ' ft');
      }
      detailsElement.innerHTML = details;
      buttonElement.classList.add('headline__buttons--hidden');
    }
    this.updateScaleHeight();
  },

  updateHeadlineMessage(title, details, buttonsVisible) {
    const buttonElement = document.querySelector('.headline__buttons');
    const toggleClassFn = buttonsVisible ? 'remove' : 'add';
    buttonElement.classList[toggleClassFn]('headline__buttons--hidden');

    if (title) {
      document.querySelector('.js-headline-title').innerHTML = title;
    }
    if (details) {
      document.querySelector('.js-headline-details').innerHTML = details;
    }
    this.updateScaleHeight();
    this.updateScale(this.currentScaleAltitude || 0);
  },

  updateScale(altitude, place) {
    altitude = this.formatAltitude(altitude);
    const pos = this.getScaleTopPositions(altitude);

    if (!place) {
      this.indicatorElement = this.indicatorElement
        || this.scaleElement.querySelector('.scale__level');

      const isInLastStep =
        altitude > this.goal - this.step && altitude < this.goal;
      this.setBannerVisibility(isInLastStep ? this.goal - this.step : altitude);

      this.scaleElement.scrollTop = pos.scaleOffsetTop;
      this.indicatorElement.style.top = `${pos.indicatorTop}px`;
      this.currentScaleAltitude = altitude;
    } else {
      place.style.top = `${pos.indicatorTop}px`;
    }
  },

  updateScaleStatus(status, altitudeIsFormatted) {
    if (!isNaN(status)) {
      var altitude = parseFloat(status);
      if (!altitudeIsFormatted) {
        altitude = this.formatAltitude(altitude);
      }
      status = TRANSLATE.text.level.scale[
        altitude < Math.round(this.goal / 3) ? "low" :
        altitude < Math.round(this.goal * 2 / 3) ? "middle" :
        altitude < this.goal ? "almost" : "done"
      ];
      const fadeStart = 30;
      const fadeEnd = 55;
      const bottom =
        altitude >= fadeEnd ? -100 :
        altitude <= fadeStart ? 30 :
        30 - ((altitude - fadeStart) / (fadeEnd - fadeStart) * 130);

      document.querySelector('.scale__level-message-fade').style.bottom =
        `${bottom}%`;
    }
    var el = document.querySelector('.js-scale-level-message');
    el.innerHTML = status;
    el.style.letterSpacing = status.length < 15 ? "" : "0.03em";
  },

  updateLastUpdateTimestamp() {
    const date = new Date();
    var   hour = date.getHours();
    const min = date.getMinutes().toString();

    const status = document.querySelector('.peak-site-footer__update-status');
    if (!status) {
      return;
    }
    const textLength = $(window).width() < 355 ? 'short' : 'long';
    var statusMsg = TRANSLATE.text.level.last_updated[textLength];

    if (/@MERIDIEM/.test(statusMsg)) {
      var meridiem = 'am';
      if (hour > 11) {
        meridiem = 'pm';
      }
      if (hour > 12) {
        hour -= 12;
      }
      statusMsg = statusMsg.replace(/@MERIDIEM/, meridiem);
    }
    const timeNow = `${hour}:${min.length < 2 ? '0' : ''}${min}`;
    status.innerHTML = statusMsg.replace(/@TIME/, timeNow);
  },

  updateScaleHeight() {
    this.scaleElement = this.scaleElement || document.querySelector('.scale');

    const scaleVisibleHeight = this.getScaleHeight();
    const buffer = 40;
    this.scaleElement.style.height = `${scaleVisibleHeight + buffer}px`;
  },

  updateLevelZindex() {
    this.indicatorElement = this.indicatorElement
      || this.scaleElement.querySelector('.scale__level');

    this.indicatorElement.style.zIndex =
      this.scaleElement.scrollTop > 0 ? 2 : 1000;
  },

  submitChallengeCompletedForm() {
    if (!localStorageIsUsable || !window.localStorage.peakEmail) {
      return;
    }
    const $form = $('#challenge-completed-form');
    $form.find('input').val(window.localStorage.peakEmail);
    $form.submit();
  },

  challengeCompletedForm: {
    retry: 5,
    flashInterval: null,

    addLoadingMessage() {
      const $details = $('.js-headline-details');
      if (!$details.find('.headline__loading-msg').length) {
        $details.html(
          `${$details.html()}
          <div class="headline__loading-msg">
            ${TRANSLATE.text.level.headline.sendingdetails.progress}
          </div>`
        );
      }
    },

    startFlashingLoadingMessage() {
      const $msg = $('.headline__loading-msg');

      clearInterval(this.flashInterval);
      this.flashInterval = setInterval(() => {
        $msg.fadeTo(500, 0.5).fadeTo(500, 1);
      }, 1000);
    },

    stopFlashingLoadingMessage() {
      clearInterval(this.flashInterval);
      $('.headline__loading-msg').stop(true).css('opacity', '');
    },

    showSuccessMessage() {
      $('.headline__loading-msg')
        .html(TRANSLATE.text.level.headline.sendingdetails.success)
        .addClass('headline__loading-msg--success');
    },

    showErrorMessage() {
      $('.headline__loading-msg')
        .html(TRANSLATE.text.level.headline.sendingdetails.error)
        .addClass('headline__loading-msg--error');
    },

    submitAjax($form) {
      this.addLoadingMessage();
      this.startFlashingLoadingMessage();

      if (this.xhr) {
        this.xhr.abort();
      }
      this.retry = 5;
      this.ajaxCall($form);
    },

    ajaxCall($form) {
      this.xhr = $.ajax({
        type: 'POST',
        url: $form[0].action,
        data: $form.serialize(),

        success: () => {
          this.stopFlashingLoadingMessage();
          this.showSuccessMessage();
          localStorage.peakReached = 1;
        },
        error: jqXHR => {
          console.log(jqXHR.responseText);
          this.retry--;

          this.stopFlashingLoadingMessage();
          this.showErrorMessage();

          if (this.retry >= 0) {
            this.ajaxCall($form);
          } else {

          }
        }
      });
    }
  },

  handleChallengeCompletedFormSubmit() {
    const $form = $('#challenge-completed-form');
    $form.submit(e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      this.challengeCompletedForm.submitAjax($form);
    });
  },

  getScaleTopPositions(altitude) {

    this.scaleElement = this.scaleElement || document.querySelector('.scale');
    const blockWrap = this.scaleElement.querySelector('.scale__block-wrap');
    const blockHeight = blockWrap.firstChild.offsetHeight;

    var scaleVisibleHeight = this.getScaleHeight();
    var scaleFullHeight = this.scaleElement.scrollHeight;

    var goal = this.goal;

    if (altitude > goal - this.step && altitude < goal) {
      altitude = goal - this.step;
    }
    var diff = goal - altitude;
    var indicatorTop = 0;
    var scaleOffsetTop = 0;

    if (diff > 0) {
      indicatorTop = goal - altitude;

      var levelRatio =
        Math.abs((scaleFullHeight - indicatorTop) / scaleFullHeight);
      var visibleIndicatorPos = scaleVisibleHeight - blockHeight -
        ((scaleVisibleHeight - (blockHeight * 2)) * levelRatio);

      scaleOffsetTop = Math.round((visibleIndicatorPos - indicatorTop) * -1);
    }
    return { scaleOffsetTop, indicatorTop };
  },

  getScaleHeight() {
    var footerElement = document.querySelector('.peak-site-footer');
    this.scaleElement = this.scaleElement || document.querySelector('.scale');

    var footerPositionTop = footerElement.getBoundingClientRect().top;
    var scalePositionTop = this.scaleElement.getBoundingClientRect().top;

    return Math.round(footerPositionTop - scalePositionTop);
  },

  formatAltitude(altitude) {
    if (altitude && USA.isUSA()) {
      altitude = USA.metersToFeet(altitude);
    }
    return altitude;
  },

  getSupportLink() {
    var lang = window.TRANSLATE.language;
    var lg_co = /(de|fr|it|es)/.test(lang) ? `${lang}-${lang}` :
    lang == "ja" ? "ja-jp" : "en-us";

    // Default is the support for Safari Mobile
    var url = `https://support.apple.com/${lg_co}/HT201357`;

    if (/(android)/i.test(window.navigator.userAgent)) {
      url = `https://support.google.com/accounts/answer/3467281?hl=${lang}`;
    }
    return url;
  },

  getRootUrl() {
    const rootMatch = window.location.href.match(/^https?:\/\/[^\/]+/);
    return rootMatch ? `${rootMatch[0]}/` :
      "http://up-the-alps.on-running.com/";
  },

  setBannerVisibility(altitude, altitudeIsFormatted) {
    if (!altitudeIsFormatted) {
      altitude = this.formatAltitude(altitude);
    }
    document.querySelector('.banner').style.opacity =
      this.goal >= altitude + this.step ? 1 : 0;
  },

  animationTimeout: null,

  animateUpdateTemplate(altitude) {
    const startAltitude = parseFloat(localStorage.accumulatedAltitude || 0);
    const newAccumulatedAltitude = this.updateTemplate(altitude);
    const altitudes =
      [startAltitude, newAccumulatedAltitude].map(n => Math.round(n));

    const distance = altitudes[1] - altitudes[0];
    const duration = distance * 6;
    this.startAnimation(...altitudes, duration > 200 ? duration : 200);
  },

  animateScale(startAltitude, endAltitude, duration = 300, timeout = 0) {

    delete window.localStorage.peakReached;
    delete window.localStorage.lastStoredAltitude;
    delete window.localStorage.accumulatedAltitude;
    clearTimeout(this.animationTimeout);

    this.startAnimation(startAltitude, endAltitude, duration, timeout);
  },

  startAnimation(startAltitude, endAltitude, duration = 300, timeout = 0) {

    this.updateTemplate(startAltitude, 'animated');

    startAltitude = this.formatAltitude(startAltitude);
    endAltitude = this.formatAltitude(endAltitude);

    const altitudeDiff = endAltitude - startAltitude;
    const pos = this.getScaleTopPositions(endAltitude);
    const indicatorTopStart = parseFloat(this.indicatorElement.style.top);
    const indicatorTopDiff = pos.indicatorTop - indicatorTopStart;

    const startAnimation = () => {
      $(this.scaleElement).stop(true).animate({
        scrollTop: pos.scaleOffsetTop
      }, {
        duration,
        progress: (a, progress, r) => {

          const newPos = indicatorTopStart + (progress * indicatorTopDiff);
          this.indicatorElement.style.top = `${newPos}px`;

          const newAlt = Math.round(startAltitude + (progress * altitudeDiff));
          const isFormatted = true;
          this.updateHeadline(newAlt, isFormatted);
          this.updateScaleStatus(newAlt, isFormatted);
          this.updateLevelZindex();
          if (endAltitude >= this.goal) {
            this.setBannerVisibility(newAlt, isFormatted);
          }
        }
      });
    };
    if (timeout) {
      this.animationTimeout = setTimeout(startAnimation, timeout);
    } else {
      startAnimation();
    }
  },

  googleAPI: {

    retry: 5,
    instance: null,

    request(lat, lng) {

      this.instance.getElevationForLocations({
        locations: [{ lat, lng }]
      },
      (results, status) => {
        clearTimeout(ELEVATION.loadingMsgTimeout);

        if (localStorage.peakReached) {
          return;
        }
        if (status === 'OK') {
          if (results[0]) {
            ELEVATION.lastPosition.lat = lat;
            ELEVATION.lastPosition.lng = lng;

            ELEVATION.animateUpdateTemplate(results[0].elevation);
          }
          else {
            console.log('No results found');
          }
          this.retry = 5;
        } else {
          console.log(`Elevation service failed due to: ${status}`);
          this.retry--;

          if (this.retry >= 0) {
            this.request(lat, lng);
          } else {
            this.errorOffline();
          }
        }
      });
    },

    errorOffline() {
      const errorMsg = TRANSLATE.text.level.headline.geolocationerror;
      $(ELEVATION.scaleElement).stop(true);
      ELEVATION.updateHeadlineMessage(false, errorMsg.offline);
    }
  },

  sendAltitudeReachedToAnalytics(newAltitude) {
    const oldAltitude = parseFloat(localStorage.accumulatedAltitude || 0);
    const gap = 100;
    const minStepReached = Math.ceil(oldAltitude / gap) * gap;
    const maxStepReached = Math.floor(newAltitude / gap) * gap;

    for (let i = minStepReached; i <= maxStepReached; i += gap) {
      let newStepReached = i && oldAltitude < i && newAltitude >= i;

      if (newStepReached && i <= this.goal) {
        ga('send', 'event', 'up-the-alps', 'altitude reached', `${i} meters`);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/javascripts/elevation.js